namespace $.$$ {
	$mol_style_define($shm_hitalama_benchmarks_page, {
		// Keep settings bounded while fitting the complete record-count selection.
		Settings: { width: '22rem', flex: { grow: 0, basis: '22rem' } },
		Computer_label: { minWidth: 0, Content: { minWidth: 0 } },
		Computer: {
			minWidth: 0, maxWidth: '100%', flex: { shrink: 1 },
			View: { minWidth: 0, maxWidth: '100%', width: '100%', overflowWrap: 'anywhere' },
		},
		Results: { width: '40rem', flex: { grow: 1, basis: '40rem' } },
	})
}
